import React from 'react';
import { Button, Header, SpaceBetween } from '@cloudscape-design/components';
import { useCopilot } from './CopilotContext';
import { CopilotMessageList } from './CopilotMessageList';
import { CopilotMessageInput } from './CopilotMessageInput';
import './Copilot.css';

export function CopilotPanel() {
  const { state, startNewConversation, togglePanel } = useCopilot();

  if (!state.isOpen) return null;

  return (
    <div className="copilot-panel">
      <div className="copilot-panel-header">
        <Header
          variant="h3"
          actions={
            <SpaceBetween direction="horizontal" size="xs">
              <Button
                variant="icon"
                iconName="refresh"
                onClick={startNewConversation}
                ariaLabel="New conversation"
              />
              <Button
                variant="icon"
                iconName="close"
                onClick={togglePanel}
                ariaLabel="Close Astra"
              />
            </SpaceBetween>
          }
        >
          Astra
        </Header>
      </div>

      <div className="copilot-panel-messages">
        <CopilotMessageList />
      </div>

      <div className="copilot-panel-input">
        <CopilotMessageInput />
      </div>
    </div>
  );
}
